import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55cbd691"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopcart-check-set" }
const _hoisted_2 = { class: "check-set-content" }
const _hoisted_3 = { class: "check-set-mian" }
const _hoisted_4 = { class: "check-set-form" }
const _hoisted_5 = { class: "check-set-form-item" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "check-set-form-item" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "check-set-form-item" }
const _hoisted_10 = { class: "text" }

import { useRouter } from 'vue-router'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, useSite } from '@/store'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { sourceCountryRef } from '../country'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'set'],
  emits: ['update:visible'],
  setup(__props, { emit: emits }) {

const props = __props


const router = useRouter()

const cancel = () => {
  emits('update:visible', false)
}
const ok = () => {
  emits('update:visible', false)
}
const jump = (path: any) => {
  const { href } = router.resolve(path)
  window.open(href, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CommonDialog, {
      visible: __props.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      "show-close": false,
      width: 500,
      className: 'shopcart-check-set-dialog ' + _unref(useSite)(),
      onOk: ok,
      onCancel: cancel,
      title: _unref(t)('注意2'),
      footer: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('完成以下配置才可使用表格导入创建订单功能')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('默认商品附加项配置')), 1),
              (!__props.set.goodsAddition)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (jump(_unref(useRtfix)('setupShop', { query: { type: 'ShopAddition', sourceCountry: _unref(sourceCountryRef) } }))))
                  }, _toDisplayString(_unref(t)('前往配置')), 1))
                : (_openBlock(), _createBlock(SvgIcon, {
                    key: 1,
                    name: "成功",
                    style: {"margin-right":"11px","font-size":"20px"}
                  }))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('默认发货附加项配置')), 1),
              (!__props.set.deliverAddition)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (jump(_unref(useRtfix)('setupShop', { query: { type: 'ShopExpress', sourceCountry: _unref(sourceCountryRef) } }))))
                  }, _toDisplayString(_unref(t)('前往配置')), 1))
                : (_openBlock(), _createBlock(SvgIcon, {
                    key: 1,
                    name: "成功",
                    style: {"margin-right":"11px","font-size":"20px"}
                  }))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('默认国际物流配置')), 1),
              (!__props.set.internationalExpress)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (jump(_unref(useRtfix)('setupShop', { query: { type: 'ShopExpress', sourceCountry: _unref(sourceCountryRef) } }))))
                  }, _toDisplayString(_unref(t)('前往配置')), 1))
                : (_openBlock(), _createBlock(SvgIcon, {
                    key: 1,
                    name: "成功",
                    style: {"margin-right":"11px","font-size":"20px"}
                  }))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "className", "title"])
  ]))
}
}

})